// extracted by mini-css-extract-plugin
export default {"container":"style_container__omN4D","video":"style_video__U6ZIr"};